$(function () {
    $('.owl-comments').owlCarousel({
        items: 2,
        nav: true,
        dotsEach: true,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            }
        }
    });

    /**
     * Sidebar slider
     */
    var swiper = new Swiper('.swiper-container.sidebar_casino_slider', {
        direction: 'vertical',
        slidesPerView: 4,
        loop: true,
        clickable: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
    });

    /**
     * Slider users asked
     */
    let swiperInstance;

    function initializeSwiper() {
        if (window.innerWidth > 1024 ) {
            if (!swiperInstance) {
                swiperInstance = new Swiper('.users-asked-list.swiper', {
                    slidesPerView: 2,
                    loop: true,
                    spaceBetween: 16,
                    pagination: {
                        el: '.users-asked-list .swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                });
            }
        } else {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        }
    }

    // Initialize Swiper on load
    initializeSwiper();

    // Reinitialize Swiper on window resize
    window.addEventListener('resize', initializeSwiper);

    /**
     * Slider for win slots
     * @type {Swiper}
     */
    let winSlotsSlider = new Swiper('.win-slots__overlay.swiper', {
        slidesPerView: 3,
        loop: true,
        spaceBetween: 8,
        pagination: {
            el: '.win-slots .swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            767: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 2.22
            },
        }
    });
});